import styled from "styled-components";
import {STRIKE_THROUGH_COLOR} from "../../_shared/colors";

export const StrikethroughText = styled.div`
  text-decoration: line-through;
  color: ${STRIKE_THROUGH_COLOR};
  margin-right: 0.5rem;
`;
